import React from 'react';

import logoImg from '../../../assets/images/kak2c_logo.svg';
import logoImgEng from '../../../assets/images/kak2c_logo_english.svg';
import LocaleSwitcher from '../../Language/LocaleSwitcher';
import { useAutoTranslation } from '../../../helpers/useAutoTranslation';

const AuthWrapper = (props) => {
  const { i18n } = useAutoTranslation();

  return (
    <div className="account-pages mt-5 mb-5">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-8 col-lg-6 col-xl-5">
            <div className="card">
              <LocaleSwitcher className="ml-auto pr-4 pt-2" />
              <div className="card-body p-4">
                <div className="text-center w-75 m-auto">
                  <a href="https://kak2c.ru/" rel="noopener">
                    <img
                      src={i18n.language === 'cn' ? logoImgEng : logoImg}
                      alt="кактус"
                      height="60"
                    />
                  </a>
                </div>
                <div style={{ marginTop: '15px' }}>{props.children}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthWrapper;
